import { useState } from 'react';
import { VehicleTechTuningItemConfig } from '~/rage/services/TechTuningService';
import { TechTuningCategory } from '~/shared';
import { useLayoutDispatch, useLayoutSelector } from '../redux';
import { setDraggedItem, setDragSource } from '../redux/slices/tuningShopSlice';

export const useTuningDrag = () => {
	const dispatch = useLayoutDispatch();
	const [dragging, setDragging] = useState(false);
	const draggedItem = useLayoutSelector(
		(state) => state.tuningShop.draggedItem,
	);

	const handleDragStart = (
		e: React.DragEvent,
		item: VehicleTechTuningItemConfig,
	) => {
		setDragging(true);
		dispatch(setDraggedItem(item));
		dispatch(setDragSource('owned'));
		e.dataTransfer.effectAllowed = 'move';
	};

	const handleDragOver = (e: React.DragEvent) => {
		e.preventDefault();
		e.dataTransfer.dropEffect = 'move';
		setDragging(true);
	};

	const handleDragEnd = () => {
		dispatch(setDraggedItem(null));
		dispatch(setDragSource(null));
		setDragging(false);
	};

	const canDropItem = (
		draggedItem: VehicleTechTuningItemConfig | null,
		targetCategory: TechTuningCategory,
	) => {
		if (!draggedItem) return false;
		return draggedItem.category === targetCategory;
	};

	return {
		dragging,
		draggedItem,
		handleDragStart,
		handleDragOver,
		handleDragEnd,
		canDropItem,
	};
};
